var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcSave = function SvgIcSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.772 1.772a.772.772 0 1 0-1.544 0v5.864l-2.05-1.952a.772.772 0 0 0-1.064 1.118l3.354 3.194a.772.772 0 0 0 1.064 0l3.354-3.194a.772.772 0 0 0-1.065-1.118l-2.05 1.952V1.772Zm-6.228 8.623a.772.772 0 1 0-1.544 0v3.833c0 .426.346.772.772.772h12.456a.772.772 0 0 0 .772-.772v-3.832a.772.772 0 1 0-1.544 0v3.06H2.544v-3.06Z"
  })));
};
export default SvgIcSave;